import React, { Fragment, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import Footer from '../../components/footer/Footer';
import './legal.css';

const LegalLayout = ({ eyebrow, title, lead, children }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Fragment>
      <div className="legal-page">
        <div className="legal-topbar">
          <div className="container">
            <NavLink to="/" className="navbar-brand">
              <img src="/images/logo.png" alt="Isuru Gimhan Logo" />
            </NavLink>
            <NavLink to="/" className="legal-back">← Back to home</NavLink>
          </div>
        </div>

        <main className="legal-body">
          <div className="container">
            <article className="legal-content">
              {eyebrow && <p className="legal-eyebrow">{eyebrow}</p>}
              <h1>{title}</h1>
              {lead && <p className="legal-lead">{lead}</p>}
              {children}
            </article>
          </div>
        </main>

        <Footer ftClass={'wpo-site-footer-s2'} />
      </div>
    </Fragment>
  );
};

export default LegalLayout;
